import PlantCheeseProduct from 'models/PlantCheeseProduct'

export const packagingInitialState = {
  category: PlantCheeseProduct.category,
  subCategory: PlantCheeseProduct.subCategory,
  Calcium: PlantCheeseProduct.Calcium,
  Protein: PlantCheeseProduct.Protein,
  CalciumCertification: PlantCheeseProduct.CalciumCertification,
  ProteinCertification: PlantCheeseProduct.ProteinCertification,
  PlantCheeseAltType: {
    value: PlantCheeseProduct.PlantCheeseAltType,
    label: 'Plant-Based Cheese Alternative Type',
  },
  OtherPlantCheeseAltType: PlantCheeseProduct.OtherPlantCheeseAltType,
  Type: {
    value: PlantCheeseProduct.Type,
    label: 'Cheese Type',
  },
  OtherType: PlantCheeseProduct.OtherType,
  Form: {
    value: PlantCheeseProduct.Form,
    label: 'Form',
  },
  PackageSize: PlantCheeseProduct.PackageSize,
}

export const plantCheeseAltTypeOptions = [
  { value: '', label: 'Plant-Based Cheese Alternative Type', isDisabled: true },
  { value: 'Almond', label: 'Almond' },
  { value: 'Cashew', label: 'Cashew' },
  { value: 'Coconut', label: 'Coconut' },
  { value: 'Soy', label: 'Soy' },
  { value: 'Other', label: 'Other' },
]

export const typeOptions = [
  { value: '', label: 'Cheese Type', isDisabled: true },
  { value: 'Cheddar - Orange - Mild', label: 'Cheddar - Orange - Mild' },
  { value: 'Cheddar - Orange - Medium', label: 'Cheddar - Orange - Medium' },
  { value: 'Cheddar - Orange - Sharp', label: 'Cheddar - Orange - Sharp' },
  {
    value: 'Cheddar - Orange - Longhorn',
    label: 'Cheddar - Orange - Longhorn',
  },
  { value: 'Cheddar - White - Mild', label: 'Cheddar - White - Mild' },
  { value: 'Cheddar - White - Medium', label: 'Cheddar - White - Medium' },
  { value: 'Cheddar - White - Sharp', label: 'Cheddar - White - Sharp' },
  { value: 'Cheddar - White - Longhorn', label: 'Cheddar - White - Longhorn' },
  { value: 'Colby', label: 'Colby' },
  { value: 'Jack', label: 'Jack' },
  {
    value: 'Marbled or Blend of Authorized Cheese',
    label: 'Marbled or Blend of Authorized Cheese',
  },
  { value: 'Mozzarella', label: 'Mozzarella' },
  { value: 'Other', label: 'Other' },
]

export const formOptions = [
  { value: '', label: 'Form', isDisabled: true },
  { value: 'Block', label: 'Block' },
  { value: 'Shredded', label: 'Shredded' },
  { value: 'Sliced', label: 'Sliced' },
  { value: 'String', label: 'String' },
]
